import cn from 'classnames';
import {Nullable, ProductBatch} from "@framework/types";

interface Props {
    className?: string;
    batches: ProductBatch[];
    selectedBatch: Nullable<ProductBatch>;
    setSelectedBatch: (batch: Nullable<ProductBatch>) => void;
}

const ProductAttributes: React.FC<Props> = ({
  className = 'mb-2 pt-0.5',
                                                batches,
                                                selectedBatch,
                                                setSelectedBatch,
}) => {
    if (!batches || batches.length == 0) return null;
  return (
    <>
        <div className={cn(className)}>
          <h4 className="mb-3 font-normal capitalize text-15px text-brand-dark text-opacity-70">
              Please selected a batch:
          </h4>
          <ul className="flex flex-wrap ltr:-mr-2 rtl:-ml-2">
              {batches.map((batch) => (
              <li
                  key={batch.id}
                className={cn(
                  'cursor-pointer rounded border h-9 md:h-10 p-1 mb-2 md:mb-3 ltr:mr-2 rtl:ml-2 flex justify-center items-center font-medium text-sm md:text-15px text-brand-dark transition duration-200 ease-in-out hover:text-brand hover:border-brand px-3',
                    {'border-brand text-brand': batch.batch_id === selectedBatch?.batch_id},
                )}
                  onClick={() => setSelectedBatch(batch)}>
                  {batch.expiration_date}
              </li>
            ))}
          </ul>
        </div>
    </>
  );
};

export default ProductAttributes;
